var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825.84 959.24H202a69.78 69.78 0 0 1-69.7-69.71v-455.3a69.78 69.78 0 0 1 69.7-69.7h623.84a69.78 69.78 0 0 1 69.7 69.7v455.3a69.78 69.78 0 0 1-69.7 69.71m-623.59-70h623.29V434.53H202.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M731.15 433a35 35 0 0 1-35-35v-84a183.4 183.4 0 0 0-52-128.33 180.74 180.74 0 0 0-126.28-55.33c-1.32 0-2.65-.05-4-.06s-2.67 0-4 .06a180.75 180.75 0 0 0-126.29 55.33 183.44 183.44 0 0 0-52 128.33v84a35 35 0 0 1-70 0v-84a253.1 253.1 0 0 1 71.79-177 250.34 250.34 0 0 1 174.94-76.62h2.3v-.06h6.58v.06h2.29A250.34 250.34 0 0 1 694.42 137a253.1 253.1 0 0 1 71.73 177v84a35 35 0 0 1-35 35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 513.9,
    cy: 618.05,
    r: 76.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M513.9 823.79a35 35 0 0 1-35-35V618.05a35 35 0 0 1 70 0v170.74a35 35 0 0 1-35 35"
  })));
};
export default SvgLock;